
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/equipments",
      function () {
        return require("private-next-pages/equipments.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/equipments"])
      });
    }
  